import * as React from 'react';

export const CheckedSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="#ffd803" stroke="#9e9e9e" strokeWidth="2"><rect width="22" height="22" rx="4" stroke="none"/><rect x="1" y="1" width="20" height="20" rx="3" fill="none"/></g><path d="M5.58,16.589l-5.34-5.34a.822.822,0,0,1,0-1.162L1.4,8.925a.821.821,0,0,1,1.162,0l3.6,3.6,7.7-7.7a.822.822,0,0,1,1.162,0L16.189,5.98a.822.822,0,0,1,0,1.162L6.742,16.589A.821.821,0,0,1,5.58,16.589Z" transform="translate(2.8 1.594)" fill="#041156"/></svg>
  );
};
